<template>
  <v-content fill-height class="skills page">
    <v-container class="mt-2 text-xs-center">
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <h1>My Skills</h1>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid>
      <v-layout row wrap class="text-xs-center">
        <v-flex xs12 sm12 md6 class="px-2">
          <v-flex xs12 sm12 md12 class="px-2">
            <img src="../assets/skills/redux.png" alt width="200">
            <img src="../assets/skills/graphql.svg" alt width="200">
          </v-flex>
          <img src="../assets/skills/react.png" alt width="200">
          <img src="../assets/skills/vue.png" alt width="200">
        </v-flex>
        <v-flex xs12 sm12 md6 class="px-2">
          <v-flex xs12 sm12 md12 class="px-2">
            <img src="../assets/skills/go-lang.png" alt width="300">
            <img src="../assets/skills/javascript.png" alt width="300">
          </v-flex>
          <img src="../assets/skills/node-js.png" alt width="300">
          <img src="../assets/skills/python.png" alt width="200">
        </v-flex>
        <v-flex xs12 sm12 md12>
          <img src="../assets/skills/mongodb.svg" alt width="200" height="200">
          <img src="../assets/skills/postgres.png" alt width="200">
          <img src="../assets/skills/mysql.png" alt width="200" height="150">
        </v-flex>
        <v-flex xs12 sm12 md12>
          <img src="../assets/skills/docker.svg" alt width="300">
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style>
</style>
